type TransactionType = 'shifts' | 'rest-days' | 'both'
export type TransactionTranslation = Record<TransactionType, string>

const getTransactionType = (shiftsCount: number, restDaysCount: number): TransactionType => {
  if (shiftsCount > 0 && restDaysCount === 0) return 'shifts'
  if (shiftsCount === 0 && restDaysCount > 0) return 'rest-days'
  return 'both'
}

export default getTransactionType
